import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

export type MediaSource = 'all' | 'uploaded' | 'generated';

export function MediaSourceSelect({
  value,
  onValueChange,
}: {
  value: MediaSource;
  onValueChange: (value: MediaSource) => void;
}) {
  return (
    <Select
      value={value}
      onValueChange={(value) => onValueChange(value as MediaSource)}
    >
      <SelectTrigger aria-label="Media source" className="w-[120px] shrink-0">
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="end">
        <SelectItem value="all">All</SelectItem>
        <SelectItem value="uploaded">Uploaded</SelectItem>
        <SelectItem value="generated">Generated</SelectItem>
      </SelectContent>
    </Select>
  );
}
